<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'Home' }">
        Mon compte
      </el-breadcrumb-item>

      <el-breadcrumb-item>
        Mes listes cadeau
      </el-breadcrumb-item>
    </el-breadcrumb>

    <el-row
      v-if="underMaintenance"
      type="flex"
    >
      <el-alert
        :closable="false"
        effect="dark"
        show-icon
        title="Maintenance"
        type="info"
      >
        Nos services sont momentanément indisponibles en raison d'activité de maintenance.<br>
        Le site sera à nouveau accessible dans quelques heures.
      </el-alert>
    </el-row>

    <el-row>
      <el-col
        v-if="!!listes && listes.length"
        :span="24"
        class="vv-liste__new-wrapper"
      >
        <router-link :to="{ name: 'NewListe' }">
          <el-tooltip
            v-if="underMaintenance"
            content="La création de liste cadeau est momentanément indisponibles en raison d'activité de maintenance."
          >
            <el-button
              type="primary"
              disabled
            >
              <span>Créer une liste cadeau</span>
              <i class="vv-liste__new-button-icon el-icon-plus el-icon-right" />
            </el-button>
          </el-tooltip>
          <el-button
            v-else
            type="primary"
          >
            <span>Créer une liste cadeau</span>
            <i class="vv-liste__new-button-icon el-icon-plus el-icon-right" />
          </el-button>
        </router-link>
      </el-col>
    </el-row>

    <template v-if="!!listes">
      <template
        v-if="listes.length === 0"
      >
        <el-row>
          <el-col
            :span="24"
          >
            <el-card shadow="never">
              <div class="vv-liste__info-link-wrapper">
                <a
                  target="_blank"
                  :href="infoUrl"
                >En savoir plus</a>
              </div>

              <p style="text-align: center;">
                Vous célébrez un mariage, un pacs, un départ à la retraite ou un anniversaire ?<br>
                Déposez votre liste chez VERDIÉ VOYAGES et offrez ou faites vous offrir un magnifique voyage.<br>
                L'ouverture de votre liste cadeau se fait en quelques clics.
              </p>

              <el-row>
                <el-col
                  :span="24"
                  class="vv-liste__new-wrapper-no-list"
                >
                  <router-link :to="{ name: 'NewListe' }">
                    <el-tooltip
                      v-if="underMaintenance"
                      content="La création de liste cadeau est momentanément indisponibles en raison d'activité de maintenance."
                    >
                      <el-button
                        size="small"
                        type="primary"
                        disabled
                      >
                        <span>Créer une liste cadeau</span>
                        <i class="vv-liste__new-button-icon el-icon-plus el-icon-right" />
                      </el-button>
                    </el-tooltip>
                    <el-button
                      v-else
                      size="small"
                      type="primary"
                    >
                      <span>Créer une liste cadeau</span>
                      <i class="vv-liste__new-button-icon el-icon-plus el-icon-right" />
                    </el-button>
                  </router-link>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </template>

      <template
        v-else
      >
        <el-divider />

        <el-row
          v-for="liste in listes"
          :key="liste.id"
        >
          <el-col
            :span="24"
          >
            <el-card
              shadow="never"
            >
              <template #header>
                <div class="vv-liste__title-wrapper">
                  <div>
                    <router-link
                      :class="{'vv-liste__title': true, 'is-link': true, 'vv-liste__title_is_closed': !liste.etatCagnotte && ((liste.userIsBeneficiaire() && liste.solde <= 0) || (liste.userIsCreateur() && !liste.userIsBeneficiaire()))}"
                      :to="{ name: 'Liste', params: { id: liste.id } }"
                    >
                      <span>{{ liste.dynamicNameBasedOnUserStatus() }}</span>
                      <span
                        v-if="!liste.etatCagnotte && liste.userIsBeneficiaire() && liste.solde <= 0"
                        class="vv-liste__title-status"
                      >&nbsp;(utilisée)</span>
                      <span
                        v-else-if="!liste.etatCagnotte && liste.userIsCreateur() && !liste.userIsBeneficiaire()"
                        class="vv-liste__title-status"
                      >&nbsp;(clôturée)</span>
                    </router-link>

                    <div
                      v-if="!!liste.dateEvenement"
                      class="vv-liste__period"
                    >
                      <template>
                        {{ liste.userIsCreateur() ? 'pour' : 'offert' }} le {{ liste.dateEvenement | date }}
                      </template>
                    </div>
                  </div>
                  <div class="vv-liste__title-montant">
                    {{ liste.totalDons | currency(true) }}
                  </div>
                </div>
              </template>

              <el-row
                :gutter="20"
                type="flex"
              >
                <el-col
                  class="vv-liste-content"
                  :span="24"
                >
                  <h4 class="vv-liste-content__title">
                    Ma liste cadeau
                  </h4>
                </el-col>

                <el-col
                  class="vv-liste-content"
                  :md="12"
                  :sm="24"
                >
                  <p class="vv-liste-content__info">
                    <span>Créateur&nbsp;:</span> {{ liste.userIsCreateur() ? 'Moi-même' : liste.nameEmetteur }}
                  </p>

                  <p class="vv-liste-content__info">
                    <span>Bénéficiaire&nbsp;:</span> {{ liste.userIsBeneficiaire() ? 'Moi-même' : liste.nameBeneficiaire }}
                  </p>

                  <p
                    v-if="liste.dateValidite"
                    class="vv-liste-content__info"
                  >
                    <span>Valable jusqu'au&nbsp;:</span> {{ liste.dateValidite | date }}
                  </p>
                </el-col>

                <el-col
                  class="vv-liste-content"
                  :md="12"
                  :sm="24"
                >
                  <p class="vv-liste-content__info">
                    <span>Nombre de participations&nbsp;:</span> {{ liste.nbParticipants }}
                  </p>

                  <p class="vv-liste-content__info">
                    <span>Montant total&nbsp;:</span> {{ liste.totalDons | currency(true) }}
                  </p>

                  <p
                    v-if="liste.userIsBeneficiaire() && !liste.etatCagnotte"
                    class="vv-liste-content__info"
                  >
                    <span>Solde&nbsp;:</span> {{ liste.solde | currency(true) }}
                  </p>
                </el-col>
              </el-row>

              <el-divider />

              <el-row type="flex">
                <el-col
                  align="center"
                  :span="24"
                >
                  <el-button
                    size="medium"
                    type="info"
                    @click="$router.push({ name: 'Liste', params: { id: liste.id } })"
                  >
                    VOIR LA LISTE CADEAU
                  </el-button>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
      </template>
    </template>
  </div>
</template>

<script>
// Librairies
import { mapGetters } from 'vuex'
import WEBSITE_URLS from '@/services/website-target'

export default {
  computed: {
    ...mapGetters(['listes', 'underMaintenance']),

    infoUrl () {
      return WEBSITE_URLS.giftlistIntro
    }
  },

  created () {
    // Démarre l'indicateur de chargement
    this.$store.commit('startLoading')

    // Récupère les données utilisées par la vue
    Promise.all([
      this.$store.dispatch('getSystemStatus'),
      this.$store.dispatch('getListes'/*, { perPage: 100 } */)
    ])
      .finally(() => {
        // Stop l'indicateur de chargement
        this.$store.commit('stopLoading')
      })
  }
}
</script>

<style lang="scss" scoped>
  .vv-liste {
    &__info-link-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      > a {
        font-size: 14px;
        margin-top: -5px;
      }
    }

    &__new {
      &-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-direction: row;

        &-no-list {
          display: flex;
          justify-content: center;
          flex-direction: row;
          margin-top: 20px;
        }
      }

      &-button {
        &-icon {
          margin-left: .5rem;
        }
      }
    }

    &__title {
      display: inline-block;
      font-size: 1.625rem;
      font-weight: 500;
      vertical-align: top;

      &_is_closed {
        color: #282a33;
      }

      &-status {
        font-style: italic;
        font-size: 1.4rem;
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        @media only screen and (max-width: 768px) {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      &-montant {
        font-size: 1.625rem;
        @media only screen and (max-width: 768px) {
          font-size: 1.5rem;
          margin-top: .5rem;
        }
      }
    }

    &__period {
      font-size: 1rem;
      font-weight: 400;
    }

    &-content {
      &__title {
        margin-bottom: 10px;
        margin-top: 0;
      }

      &__alert {
        margin-bottom: 10px;
      }

      &__info {
        margin: 0;

        span {
          display: inline-block;
          vertical-align: top;
        }
      }
    }
  }
</style>
